import { ContactAddress, Gender } from "cy-api/simple-payments/common-models";
import { AccountLimit, AccountType } from "cy-remittance/registration";
import { BanknoteIcon, SquareUserRoundIcon } from "lucide-react";
import { z } from "zod";

export const Step = z.enum([
  "start",
  "accountType",
  "accountLimit",
  "personal",
  "password",
  "otp",
  "done",
]);
export type Step = z.infer<typeof Step>;
export const stepFlow: Step[] = [
  "start",
  "accountType",
  "accountLimit",
  "personal",
  "password",
  "otp",
  "done",
];
export interface Country {
  name: string;
  countryCode: string;
  countryCode3: string;
  disabled: boolean;
}
export interface PersonalInfoInputs {
  firstName: string;
  middleName: string;
  lastName: string;
  sourceofFunds?: number | null;
  occupation?: number | null;
  southAfricanId?: string;

  dateOfBirth: {
    day: number;
    month: number;
    year: number;
  };
  gender: Gender;
}

export interface AddressInputs {
  physicalAddress: ContactAddress;
  nationality?: number;
}

export enum AccountTypes {
  SouthAfrican = "south_african",
  ForeignNational = "foreign_national",
}
export const accountTypes: AccountType<AccountTypes>[] = [
  {
    id: AccountTypes.SouthAfrican,
    name: "South African ID Holders",
    label: "South African Four O One",
    description:
      "You will need a copy of your SA Green bar coded ID book or SA Smartcard ID.",
    icon: <SquareUserRoundIcon />,
  },
  {
    id: AccountTypes.ForeignNational,
    name: "Foreign National, residing in South Africa",
    description:
      "You will need a copy of your passport or temporary resident permit.",
    icon: <SquareUserRoundIcon />,
  },
];

export enum AccountLimits {
  Standard = "standard",
  Boost = "boost",
}

export const accountLimits: AccountLimit<AccountLimits>[] = [
  {
    id: AccountLimits.Standard,
    name: "Standard",
    label: "Foreign National Four One Six",
    description: "Up to ZAR 5,000 per day / ZAR 15,000 per month.",
    icon: <BanknoteIcon />,
  },
  {
    id: AccountLimits.Boost,
    name: "Boost",
    label: "Foreign National Four One Seven",
    description: "Up to ZAR 5,000 per day / ZAR 25,000 per month.",
    icon: <BanknoteIcon />,
  },
];
